import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import PropTypes from "prop-types";

export default function ConfirmDialog({
  isOpen,
  handleClose,
  handleConfirm,
  isLoading,
  title,
  actionText,
}) {
  return (
    <Dialog
      sx={{
        "& .MuiDialog-paper": {
          width: "450px",
          maxWidth: "90%",
          borderRadius: "10px",
        },
        "& .MuiDialogContent-root": {
          padding: "32px 26px 16px 26px",
        },
        "& .MuiDialogActions-root": {
          padding: "16px 24px 24px 24px",
        },
      }}
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="confirm-dialog-title"
    >
      <DialogContent>
        <SoftBox mb={1}>
          <SoftTypography 
            variant="h6" 
            fontWeight="medium"
            textAlign="center"
          >
            {title}
          </SoftTypography>
        </SoftBox>
      </DialogContent>
      <DialogActions>
        <SoftBox display="flex" gap={2} width="100%" justifyContent="center">
          <SoftButton 
            variant="gradient" 
            color="dark"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </SoftButton>
          <SoftButton 
            variant="gradient" 
            color="info"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Processing..." : "Confirm"}
          </SoftButton>
        </SoftBox>
      </DialogActions>
    </Dialog>
  );
}

ConfirmDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  actionText: PropTypes.string.isRequired,
};
